import { HuaweiBridgeClient } from './huawei-bridge-client';
/**
 * CoreHuawei implements the same CorePlugin interface as aigens-sdk-core,
 * but routes all method calls through the Huawei JS Bridge to HarmonyOS native.
 *
 * This class is used when `isHuaWei()` returns true (Huawei WebView detected via UA).
 * It serves as a drop-in replacement for Capacitor's `Core` plugin object.
 */
export class CoreHuawei {
    constructor() {
        this.bridge = HuaweiBridgeClient.getInstance();
    }
    async getMember(options) {
        return this.bridge.call('getMember', options || {});
    }
    async getDeeplink(options) {
        return this.bridge.call('getDeeplink', options || {});
    }
    async dismiss(options) {
        return this.bridge.call('dismiss', { closedData: options });
    }
    async finish(options) {
        return this.bridge.call('finish', { closedData: options });
    }
    async isInstalledApp(options) {
        return this.bridge.call('isInstalledApp', options);
    }
    async isDebug() {
        return this.bridge.call('isDebug');
    }
    async isHuawei() {
        const huawei = navigator.userAgent.toLowerCase().includes('huawei-aigens');
        return { huawei };
    }
    async openExternalUrl(options) {
        return this.bridge.call('openExternalUrl', options);
    }
    async setTextZoom(options) {
        return this.bridge.call('setTextZoom', options);
    }
    async readClipboard() {
        return this.bridge.call('readClipboard');
    }
    async makeHKFPSPayment(options) {
        return this.bridge.call('makeHKFPSPayment', options);
    }
    async setNativeBackPressEnabled(options) {
        return this.bridge.call('setNativeBackPressEnabled', options);
    }
    setNativeBackPressHandler(callback) {
        window.aigensNativeBackPress = callback;
        this.bridge.call('setNativeBackPressHandler', {}).then((res) => {
            if (res && res.enabled === false) {
                console.warn('setNativeBackPressHandler: NativeBackPressEnabled = false, handler will not fire');
            }
        }).catch((e) => {
            console.error('setNativeBackPressHandler: bridge call failed: ' + e.message);
        });
    }
}
//# sourceMappingURL=huawei.js.map